if (!customElements.get('learn-section-nav')) {
  class LearnSectionNav extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-target]'));
      this.list = this.querySelector('.learn-tabs__list');
      this.gap = 12;
      this.ticking = false;
      this.current = null;

      this.onScroll = () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.update(), 350);
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      };

      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.getElementById(link.dataset.target);
          if (!target) return;
          event.preventDefault();
          this.update();
          const pin = target.querySelector('learn-formula-compare');
          const top = pin
            ? pin.getBoundingClientRect().top + window.scrollY + 16
            : target.getBoundingClientRect().top + window.scrollY - this.offset() + 1;
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
          if (pin) {
            const settle = () => {
              window.removeEventListener('scrollend', settle);
              const off = pin.getBoundingClientRect().top;
              if (off > -16) window.scrollBy({ top: off + 16, behavior: 'auto' });
            };
            window.addEventListener('scrollend', settle);
            setTimeout(settle, 1200);
          }
          history.replaceState(null, '', `#${link.dataset.target}`);
        });
      });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }


    offset() {
      return this.pinnedTop() + this.offsetHeight + 16;
    }

    pinnedTop() {
      if (!window.matchMedia('(min-width: 990px)').matches) return this.gap;
      const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
      const height = header ? header.getBoundingClientRect().height : 0;
      if (!height) return this.gap;
      return Math.max(4, Math.round((height - this.offsetHeight) / 2));
    }

    update() {
      const navTop = this.pinnedTop();
      const root = document.documentElement;
      root.style.setProperty('--learn-nav-top', `${navTop}px`);
      root.style.setProperty('--learn-scroll-offset', `${navTop + this.offsetHeight + 16}px`);

      const nav = this.closest('.learn-nav');
      const formula = document.querySelector('learn-formula-compare');
      if (nav && this.dataset.sticky === 'true') {
        nav.classList.toggle('is-pinned', this.getBoundingClientRect().top <= navTop + 1);
      }
      const formulaBar = formula && formula.querySelector('.learn-formula__sticky');
      if (formulaBar) {
        const pill = formulaBar.querySelector('.learn-tabs');
        formulaBar.classList.toggle('is-pinned', !!pill && pill.getBoundingClientRect().top <= navTop + 1);
      }
      if (nav && formula && this.dataset.sticky === 'true') {
        const rect = formula.getBoundingClientRect();
        const tabs = formula.querySelector('.learn-formula__sticky');
        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        nav.classList.toggle('is-yielding', rect.top <= navTop + 2 && rect.bottom > navTop + tabsHeight + 24);
      }

      const line = this.offset() + 8;
      let active = this.links[0] || null;
      this.links.forEach((link) => {
        const target = document.getElementById(link.dataset.target);
        if (target && target.getBoundingClientRect().top <= line) active = link;
      });
      this.setActive(active);
    }

    setActive(link) {
      if (!link || link === this.current) return;
      this.current = link;
      this.links.forEach((item) => {
        const on = item === link;
        item.classList.toggle('is-active', on);
        if (on) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      if (this.list && this.list.scrollWidth > this.list.clientWidth) {
        const item = link.parentElement;
        const left = item.offsetLeft - (this.list.clientWidth - item.offsetWidth) / 2;
        this.list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
  }

  customElements.define('learn-section-nav', LearnSectionNav);
}
